import { EBool } from '~/src/dash/api/types/bool';
import {
  RouteBrandSafetyList,
  RouteBrandsDashboard,
  RouteInventoryForecast,
  RouteInventoryRouteList,
  RouteMonitorList,
  RouteNetworkDashboard,
  RouteNetworkList,
  RouteReportsList,
} from '~/src/dash/router/routes';
import {
  INavBarConfig,
  INavBarSingleRow,
  IPermissionParams,
  NavBarItemLabels,
} from '~/src/dash/views/navbar/configs/defaultCfg';

// TODO: in the future, when we have clients who is SSAI only. We should add a ssai_only column on publisher table
// Then use navbarConfigSSAI for those clients
export const navbarConfigSSAI = {
  sections: {
    Main: {
      label: 'Main',
      isLabelDisplayed: false,
      items: [
        {
          isSubMenu: true,
          label: 'Ad Insertion',
          iconPath: '/assets/shared/svg/navbar/AdInsertion16.svg',
          iconPathDark: '/assets/shared/svg/navbar/black/AdInsertion16.svg',
          permChecks: ['read_network', 'write_network'],
          subViews: ['network-dashboard', 'network-list', 'network'],
          subItems: [
            {
              label: 'Dashboard',
              eventName: 'Sidebar - SSAI Dashboard',
              route: RouteNetworkDashboard,
              pathString: 'network-dashboard',
            },
            {
              label: 'Networks',
              eventName: 'Sidebar - Network',
              route: RouteNetworkList,
              pathString: 'network-list',
              customActiveCheck: (pathname) =>
                (pathname.indexOf('network-list') > -1 || pathname.indexOf('network') > -1) &&
                !(pathname.indexOf('network-dashboard') > -1),
            },
          ],
          checkIfHidden: (permissionParams: IPermissionParams) => {
            return permissionParams.session.publisher.NetworkEnabled !== EBool.EBool_TRUE;
          },
        },
        {
          label: NavBarItemLabels.REPORTING,
          iconPath: '/assets/shared/svg/navbar/ReportingNew16.svg',
          iconPathDark: '/assets/shared/svg/navbar/black/ReportingNew16.svg',
          eventName: 'Sidebar - Reporting',
          route: RouteReportsList,
          permChecks: ['read_report', 'write_report'],
        },
      ] as INavBarSingleRow[],
    },
    Inventory: {
      label: 'Inventory',
      isLabelDisplayed: true,
      items: [
        {
          label: NavBarItemLabels.ROUTES,
          iconPath: '/assets/shared/svg/route.svg',
          iconPathDark: '/assets/shared/svg/route_black.svg',
          eventName: 'Sidebar - Routes',
          route: RouteInventoryRouteList,
        },
      ] as INavBarSingleRow[],
    },
    Miscellaneous: {
      label: 'Miscellaneous',
      isLabelDisplayed: false,
      items: [
        {
          label: NavBarItemLabels.BRAND_SAFETY,
          iconPath: '/assets/shared/svg/navbar/BrandSafety16.svg',
          iconPathDark: '/assets/shared/svg/navbar/black/BrandSafety16.svg',
          eventName: 'Sidebar - Brand Safety',
          route: RouteBrandSafetyList,
          permChecks: ['read_channel_brandsafety_rule', 'write_channel_brandsafety_rule'],
        },
        {
          label: NavBarItemLabels.BRANDS_DASHBOARD,
          iconPath: '/assets/shared/svg/navbar/BrandsDash16.svg',
          iconPathDark: '/assets/shared/svg/navbar/black/BrandsDash16.svg',
          eventName: 'Sidebar - Brands Dashboard',
          route: RouteBrandsDashboard,
        },
        {
          isSubMenu: true,
          label: NavBarItemLabels.TOOLS,
          iconPath: '/assets/shared/svg/navbar/Tools16.svg',
          iconPathDark: '/assets/shared/svg/navbar/black/Tools16.svg',
          subViews: ['inventory-forecast', 'monitor'],
          subItems: [
            {
              label: 'Inventory Forecast',
              eventName: 'Sidebar - Inventory Forecast',
              route: RouteInventoryForecast,
              pathString: 'inventory-forecast',
            },
            {
              label: 'Monitors',
              eventName: 'Sidebar - Monitors',
              route: RouteMonitorList,
              pathString: 'monitor',
            },
          ],
        },
      ] as INavBarSingleRow[],
    },
  },
} as INavBarConfig;
